import { useState, useEffect, useRef } from 'react'
import { useForm } from 'react-hook-form'
import SignaturePad from 'react-signature-canvas'
import '../formcomponents/ElectronicSignature.css'
import IformBreadcrumb from '../formcomponents/iformBreadcrumb'
import { Typography, Button } from '@nwh-consumer-digital/nw-component-lib'
import ErrorMessage from '../formcomponents/errorMessage'
import { Grid, Box, Paper, Stack, useMediaQuery } from '@mui/material'
import styled from '@emotion/styled'
import { useProgress } from '../context/ProgressContext'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fal, faCircleExclamation } from '@fortawesome/pro-light-svg-icons'
library.add(fal, faCircleExclamation)

const Item = styled(Paper)(({ theme }) => ({
  textAlign: 'left',
  minHeight: '65px',
  lineHeight: '60px',
}))

const styles = {
  signatureSectionCont: {
    padding: '10px',
  },
  errorMsgCont: {
    display: 'grid',
    clear: 'both',
    width: '100%',
    paddingTop: '40px',
  },
}

const adultPageThree = (props) => {
  const isMobile = useMediaQuery('(max-width:600px)')

  const { updateProgress } = useProgress()
  updateProgress(75)

  const scrollToTop = () => {
    window.scrollTo(0, 0)
  }

  // Scroll to top when page mounts
  useEffect(() => {
    scrollToTop()
  }, [])

  // Setup Ref for Signature Pad Container and Handle Error States  const cardRef = useRef(null)
  const cardRef = useRef(null)

  const removeBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '1px solid #cccccc'
    }
  }
  const addBottomBorderRed = () => {
    if (cardRef.current) {
      cardRef.current.style.borderBottom = '3px solid red'
    }
  }

  const handleSignature = () => {
    setTimeout(() => {
      setIsSigned(true)
    }, 300)
    removeBottomBorderRed()
  }

  const { SubmissionState, onFormStateChange } = props
  const { register, handleSubmit, setValue } = useForm()
  const [isSigned, setIsSigned] = useState(false)
  const [imageURL, setImageURL] = useState(null)
  const signData = useRef({})

  const proxyAccessLevel = SubmissionState.sectionTwoForm?.proxyAccessLevel
  const proxyName =
    SubmissionState.sectionTwoForm?.firstNameGuardian + ' ' + SubmissionState.sectionTwoForm?.lastNameGuardian

  const setCardColor = (color) => {
    const sigPadElements = document.getElementsByClassName('SigPad')
    if (sigPadElements[0]) {
      sigPadElements[0].style.backgroundColor = color
    }
    if (cardRef.current) {
      cardRef.current.style.backgroundColor = color
    }
  }

  const clear = () => {
    setImageURL('reset')
    addBottomBorderRed()
    setIsSigned(false)
    signData.current.clear()
    setCardColor('#FAFAFA')
  }

  const save = () => {
    const dataUrl = signData.current.getTrimmedCanvas().toDataURL('image/png')
    setImageURL(dataUrl)
    setValue('imageURLStr', 'True')
    setCardColor('#E8F0FE')
    setIsSigned(true)
  }

  const saveIfNotEmpty = () => {
    if (signData.current.isEmpty()) {
      setIsSigned(false)
    } else {
      save()
    }
  }

  const handleRegistration = (data) => {
    if (imageURL) {
      setValue('imageURLStr', 'True')
      setIsSigned(true)
    }

    data.imageUrl = imageURL
    data.uploadFiles = 'See Folder Images'
    SubmissionState.sec = data
    SubmissionState.sectionThreeForm = data
    SubmissionState.sectionThreSubmitted = true
    SubmissionState.goBackPageOne = false
    SubmissionState.goBackPageTwo = false
    SubmissionState.goBackLogin = false
    SubmissionState.goPageFour = true
    SubmissionState.submitCompletedForm = false
    onFormStateChange()
  }

  const previousPageClick = () => {
    SubmissionState.showPageThree = false
    SubmissionState.showPageTwo = true
    SubmissionState.goBackPageTwo = true
    SubmissionState.goPageThree = false
    onFormStateChange()
  }

  return (
    <Box>
      <Grid container spacing={1} justifyContent="space-between" alignItems="left">
        <Grid
          item
          xs={12}
          sx={{
            marginTop: {
              xs: '1.25rem',
              sm: '1.25rem',
              md: '1.25rem',
              lg: '2rem',
              xl: '2rem',
            },
            marginBottom: {
              xs: '2rem',
              sm: '2rem',
              md: '2rem',
              lg: '2rem',
              xl: '2rem',
            },
          }}>
          <IformBreadcrumb onClick={previousPageClick}>&lt; 您的信息</IformBreadcrumb>
        </Grid>
        <Grid item xs={12} sm={6} md={12}>
          <Item elevation={0}>
            <Typography variant="h1" style={{ marginBottom: 24 }}>
              患者/法定代表人签名
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography variant="h2" style={{ marginLeft: -4, marginBottom: 16, fontSize: 20 }}>
              本人确认并同意:
            </Typography>
          </Item>
          <Item elevation={0}>
            <Typography type="body" size="large" weight="light">
              <ul>
                <li>本人必须遵守 Northwell 网站上的条款和条件。</li>
                <li>
                  下述代理人将有权以上述方式访问本人的 MyNorthwell 账户，包括访问本人当前可获取的医疗信息，以
                  及未来接受医疗护理时可能存入的医疗信息。
                </li>
                <li>代理人可能有权获取本人希望保密的信息。</li>
                <li>
                  本人可以随时撤销代理人的访问权限，撤销方法是访问 MyNorthwell 账户菜单中的“Share My Record”
                  （共享我的记录）选项卡，选择“Friend and family access”（朋友和家人访问权限），然后单击代理人姓名
                  旁边的“Revoke”（撤销）按钮，或者通过电子邮件提交书面撤销申请，邮箱： northwellproxy@northwell.edu
                </li>
                <li>
                  除非本人撤销自己代理人的访问权限，否则本人的代理人可以持续访问本人 MyNorthwell 账户，直到本
                  人撤销该访问权限为止。
                </li>
                <li>
                  一旦 Northwell 将健康信息披露给代理人，该信息可能会被再次披露，而且所披露的信息可能不再
                  受联邦和州隐私法的保护。
                </li>
              </ul>
            </Typography>
          </Item>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h2" style={{ marginLeft: -10, marginBottom: 16, fontSize: 20 }}>
            通过在下方签名，本人希望将以下权限授予下述代理人：{' '}
            <Typography component="span" style={{ fontSize: 20, fontWeight: 'bold' }}>
              {proxyName}, {proxyAccessLevel === 'Full Access' ? '完全访问权限' : '只读权限'}
            </Typography>{' '}
            到 MyNorthwell 帐户。
          </Typography>
        </Grid>
        <form onSubmit={handleSubmit(handleRegistration)}>
          <Grid item xs={12}>
            <Item elevation={0}>
              <div className="Card" ref={cardRef}>
                <Typography type="body" size="small" weight="plain" style={{ marginTop: 10, marginLeft: 16 }}>
                  {' '}
                  需成人患者签名<span className="red"> *</span>
                </Typography>
                <div className="SigContainer">
                  <SignaturePad
                    onEnd={handleSignature}
                    penColor="black"
                    canvasProps={{ className: 'SigPad' }}
                    ref={signData}
                  />
                  <div>{!isSigned ? <ErrorMessage message="需成人患者签名。" /> : null}</div>
                  <Stack spacing={2} direction={isMobile ? 'column' : 'row'}>
                    <Button size="medium" color="primary" onClick={saveIfNotEmpty} type="submit" text="提交" />
                    <Button size="medium" color="secondary" onClick={clear} type="button" text="重置签名" />
                  </Stack>
                </div>
              </div>
              <input {...register('imageURLStr', { required: true })} type="hidden" />
              <div style={styles.errorMsgCont}></div>
            </Item>
          </Grid>
        </form>
      </Grid>
    </Box>
  )
}

export default adultPageThree
